/**
* @ngdoc component
* @name common.equivalence.component:itxEquivalenceCmp
*
* @description
* Equivalence size guide component
*/
(function() {

    'use strict';

    var equivalenceCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'equivalence.component.html',
        controller: equivalenceCtrl,
        bindings: {
            product: '<',
            goToMeasureMyself: '&'
        }
    };

    equivalenceCtrl.$inject = ['$http', 'timestampSvc', 'ItxScreenSizeSvc', 'ItxProductSvc','ItxTranslateSvc'];

    function equivalenceCtrl( $http, timestampSvc, ItxScreenSizeSvc, ItxProductSvc,ItxTranslateSvc) {

        var _this = this;

        _this.confSizeGuide = false;
        _this.ItxScreenSizeSvc = ItxScreenSizeSvc;
           
        _this.$onInit = function () {
            $http.get(window.staticContent + '/configurations/size_guide.json?t=' + timestampSvc.getTs())
                .then(function(res) {
                    _this.gender = 'men';
                    switch (_this.product.section) {
                        case '2':
                            _this.gender = 'men';
                            break;
                        case '3':
                            _this.gender = 'boysgirls';
                            break;
                        default:
                            _this.gender = 'women';
                            break;
                    }
                    _this.data = res.data[_this.gender];
                    _this.goToNumberSection = ItxProductSvc.getType(_this.product);
                    _this.confSizeGuide = true;
                    switch (inditex.iCountryCode) {
                        case 'CA':
                        case 'US':
                        case 'GB':
                            _this.centimeter = false;
                            break;
                        default:
                            _this.centimeter = true;
                            break;
                    }
                });

            _this.translations = {
                accessory: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.info'),
                footwear: ItxTranslateSvc.translateCms('legacy.sizeGuide.footwear.info'),

                upper_part_women: ItxTranslateSvc.translateCms('legacy.sizeGuide.women.upperPart.info'),
                lower_part_women: ItxTranslateSvc.translateCms('legacy.sizeGuide.women.lowerPart.info'),
                
                lower_part_men_denim: ItxTranslateSvc.translateCms('legacy.sizeGuide.men.lowerPartDenim.info'),
                
                lower_part_men: ItxTranslateSvc.translateCms('legacy.sizeGuide.men.lowerPart.info'),
                upper_part_men_all: ItxTranslateSvc.translateCms('legacy.sizeGuide.men.upperPart.all'),// 'Abrigos / Americanas / Chalecos / Cazadoras de piel / Chaquetas Desportivas / Jerseys / Cardigans / Camisetas / Polos',
                upper_part_men_shirt: ItxTranslateSvc.translateCms('legacy.sizeGuide.men.upperPart.shirt'), //'Camisas de vestir',
                
                glove: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.glove.title'),
                ring: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.ring.title'),
                belt: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.belt.title'),
                total_length_glove: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.glove.totalLengthGlove'),
                length_glove: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.glove.lengthGlove'),
                long_finger: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.glove.longFinger'),
                broad_fist: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.glove.broadFist'),
                ring_product: ItxTranslateSvc.translateCms('legacy.sizeGuide.measure.ring'),
                neck: ItxTranslateSvc.translateCms('legacy.sizeGuide.measure.neck'), //'Medidas contorno cuello '
                belt_waist: ItxTranslateSvc.translateCms('legacy.sizeGuide.measure.beltWaist'),
                belt_hip: ItxTranslateSvc.translateCms('legacy.sizeGuide.measure.beltHip'),
                foot: ItxTranslateSvc.translateCms('legacy.sizeGuide.measure.foot'),
                chest: ItxTranslateSvc.translateCms('legacy.sizeGuide.measure.chest'),
                hip: ItxTranslateSvc.translateCms('legacy.sizeGuide.measure.hip'),
                
                year: ItxTranslateSvc.translateCms('legacy.sizeGuide.year'),

                accessory_nav: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.title'),
                accessory_girl_nav: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.girl.title'),
                accessory_boy_nav: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.boy.title'),
                lower_part_nav: ItxTranslateSvc.translateCms('legacy.sizeGuide.lowerPart.title'),
                upper_part_nav: ItxTranslateSvc.translateCms('legacy.sizeGuide.upperPart.title'),
                footwear_nav: ItxTranslateSvc.translateCms('legacy.sizeGuide.footwear.title'),
                extras_nav: ItxTranslateSvc.translateCms('legacy.sizeGuide.extras'), //'Extras',
                upper_part_boysgirls_nav: ItxTranslateSvc.translateCms('legacy.sizeGuide.boysGirls.upperPart.info'),//'Ropa (niño y niña)',

                hand_contour: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.handContour'),//'Contorno de manos',
                sock: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.socksTitle'), //'Calcetines',
                sock_boysgirls: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.socksTitle') ,// 'Calcetines (niño y niña)',
                
                belt_girl: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.belt.title'),//'Cinturones niña',
                belt_boy: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.belt.title'), //'Cinturones niño',
                long_measure: ItxTranslateSvc.translateCms('legacy.sizeGuide.measure.long'), // Longitud ',
                footwear_boysgirl: ItxTranslateSvc.translateCms('legacy.sizeGuide.boysGirls.footwear.title'), //'CALZADO (Niño y Niña)',
                hat: ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.hat'), //'CALZADO (Niño y Niña)',

                store_key: {
                    'eu': ItxTranslateSvc.translateCms('legacy.sizeGuide.world.europe'),// 'Europa',
                    'gb': ItxTranslateSvc.translateCms('legacy.sizeGuide.world.uk'), // 'uk',
                    'cn': ItxTranslateSvc.translateCms('legacy.sizeGuide.world.china'),//'China',
                    'us': ItxTranslateSvc.translateCms('legacy.sizeGuide.world.usa'),//'usa',
                    'ko': ItxTranslateSvc.translateCms('legacy.sizeGuide.world.korea'),//'Corea',
                    'me': ItxTranslateSvc.translateCms('legacy.sizeGuide.world.mexico'),//'Mexico',
                    'ru': ItxTranslateSvc.translateCms('legacy.sizeGuide.world.rusia'),//'Rusia',
                    'it': ItxTranslateSvc.translateCms('legacy.sizeGuide.world.italy') //'Italia'
                },
                boysgirls_height:  ItxTranslateSvc.translateCms('legacy.sizeGuide.boysGirls.measure.height'), //Altura ',
                boysgirls_chest: ItxTranslateSvc.translateCms('legacy.sizeGuide.boysGirls.measure.chest'), // 'Pecho',
                boysgirls_hip: ItxTranslateSvc.translateCms('legacy.sizeGuide.boysGirls.measure.hip'),// 'Cadera',
                boysgirls_crotch: ItxTranslateSvc.translateCms('legacy.sizeGuide.boysGirls.measure.crotch'), //'Largo entrepierna',
                homewear:  ItxTranslateSvc.translateCms('legacy.sizeGuide.accessory.homewear'), //Homewear Baño '

                textInche: ItxTranslateSvc.translateCms('legacy.sizeGuide.measure.in.title'),

                // Lenceria
                lingerie_nav: ItxTranslateSvc.translateCms('dev.product.sizeGuide.lingerie'),
                lingerie_upper_part_women: ItxTranslateSvc.translateCms('dev.product.sizeGuide.lingerie_upper_part_women'),
                chest_contour_size: ItxTranslateSvc.translateCms('dev.product.sizeGuide.chest_contour_size'),
                chest_contour: ItxTranslateSvc.translateCms('dev.product.sizeGuide.chest_contour'),
                b_cup_bra: ItxTranslateSvc.translateCms('dev.product.sizeGuide.b_cup_bra'),
                c_cup_bra: ItxTranslateSvc.translateCms('dev.product.sizeGuide.c_cup_bra'),
                lingerie_lower_part_women: ItxTranslateSvc.translateCms('dev.product.sizeGuide.lingerie_lower_part_women'),
                hip_size: ItxTranslateSvc.translateCms('dev.product.sizeGuide.hip_size'),
                waist_contour: ItxTranslateSvc.translateCms('dev.product.sizeGuide.waist_contour'),
                hip_contour: ItxTranslateSvc.translateCms('dev.product.sizeGuide.hip_contour')

            };

        };

    }

    angular.module('itxApp.common')
        .component('equivalence', equivalenceCmp);

})();